/* eslint-disable */
export const getBanksJSON_LD = (name, banksList, currentCurrency) => (
  JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": name,
      "mainEntity": {
        "@type": "ItemList",
        "itemListElement": banksList.reduce((acc, bank) => {
          return acc.concat([{
            "@type": "SellAction",
            "agent": {
              "@type": "BankOrCreditUnion",
              "name": bank.bankTitle,
              "image": bank.bankLogoUrl
            },
            "object": {
              "@type": "ExchangeRateSpecification",
              "currency": currentCurrency,
              "currentExchangeRate": {
                "@type": "UnitPriceSpecification",
                "price": bank.sell,
                "priceCurrency": "KZT"
              }
            }
          }, {
            "@type": "BuyAction",
            "agent": {
              "@type": "BankOrCreditUnion",
              "name": bank.bankTitle,
              "image": bank.bankLogoUrl
            },
            "object": {
              "@type": "ExchangeRateSpecification",
              "currency": currentCurrency,
              "currentExchangeRate": {
                "@type": "UnitPriceSpecification",
                "price": bank.buy,
                "priceCurrency": "KZT"
              }
            }
          }])
        }, [])
      }
    }
  )
)
